'use client'

import { useMandatoryContext } from '@repo/hooks'
import { createContext, type PropsWithChildren } from 'react'

import { useAnalyticsConsent } from '@/lib/analytics/client/consent'

type AnalyticsConsentContextValue = ReturnType<typeof useAnalyticsConsent>

const AnalyticsConsentContext = createContext<AnalyticsConsentContextValue | null>(null)

/**
 * Hosts the single `useAnalyticsConsent()` instance for the app so that every
 * consumer (the "Share analytics" switch, Spindl, wallet attribution) observes
 * the same in-session state. The shared hook keeps its state per instance, so
 * consumers must read it through this context rather than calling it directly.
 */
export const AnalyticsConsentProvider = ({ children }: PropsWithChildren) => {
  const value = useAnalyticsConsent()

  return (
    <AnalyticsConsentContext.Provider value={value}>{children}</AnalyticsConsentContext.Provider>
  )
}

export const useAnalyticsConsentContext = () => {
  return useMandatoryContext(AnalyticsConsentContext, 'AnalyticsConsent')
}
